// Country dial codes used by the profile phone inputs. Names are lowercase to
// match the settings UI, which renders all of its labels in lowercase.
export const countryDialCodes = [
  { code: 'AF', name: 'afghanistan', dial: '+93' },
  { code: 'AL', name: 'albania', dial: '+355' },
  { code: 'DZ', name: 'algeria', dial: '+213' },
  { code: 'AS', name: 'american samoa', dial: '+1684' },
  { code: 'AD', name: 'andorra', dial: '+376' },
  { code: 'AO', name: 'angola', dial: '+244' },
  { code: 'AI', name: 'anguilla', dial: '+1264' },
  { code: 'AG', name: 'antigua and barbuda', dial: '+1268' },
  { code: 'AR', name: 'argentina', dial: '+54' },
  { code: 'AM', name: 'armenia', dial: '+374' },
  { code: 'AW', name: 'aruba', dial: '+297' },
  { code: 'AU', name: 'australia', dial: '+61' },
  { code: 'AT', name: 'austria', dial: '+43' },
  { code: 'AZ', name: 'azerbaijan', dial: '+994' },
  { code: 'BS', name: 'bahamas', dial: '+1242' },
  { code: 'BH', name: 'bahrain', dial: '+973' },
  { code: 'BD', name: 'bangladesh', dial: '+880' },
  { code: 'BB', name: 'barbados', dial: '+1246' },
  { code: 'BY', name: 'belarus', dial: '+375' },
  { code: 'BE', name: 'belgium', dial: '+32' },
  { code: 'BZ', name: 'belize', dial: '+501' },
  { code: 'BJ', name: 'benin', dial: '+229' },
  { code: 'BM', name: 'bermuda', dial: '+1441' },
  { code: 'BT', name: 'bhutan', dial: '+975' },
  { code: 'BO', name: 'bolivia', dial: '+591' },
  { code: 'BA', name: 'bosnia and herzegovina', dial: '+387' },
  { code: 'BW', name: 'botswana', dial: '+267' },
  { code: 'BR', name: 'brazil', dial: '+55' },
  { code: 'IO', name: 'british indian ocean territory', dial: '+246' },
  { code: 'VG', name: 'british virgin islands', dial: '+1284' },
  { code: 'BN', name: 'brunei', dial: '+673' },
  { code: 'BG', name: 'bulgaria', dial: '+359' },
  { code: 'BF', name: 'burkina faso', dial: '+226' },
  { code: 'BI', name: 'burundi', dial: '+257' },
  { code: 'KH', name: 'cambodia', dial: '+855' },
  { code: 'CM', name: 'cameroon', dial: '+237' },
  { code: 'CA', name: 'canada', dial: '+1' },
  { code: 'CV', name: 'cape verde', dial: '+238' },
  { code: 'BQ', name: 'caribbean netherlands', dial: '+599' },
  { code: 'KY', name: 'cayman islands', dial: '+1345' },
  { code: 'CF', name: 'central african republic', dial: '+236' },
  { code: 'TD', name: 'chad', dial: '+235' },
  { code: 'CL', name: 'chile', dial: '+56' },
  { code: 'CN', name: 'china', dial: '+86' },
  { code: 'CO', name: 'colombia', dial: '+57' },
  { code: 'KM', name: 'comoros', dial: '+269' },
  { code: 'CG', name: 'congo - brazzaville', dial: '+242' },
  { code: 'CD', name: 'congo - kinshasa', dial: '+243' },
  { code: 'CK', name: 'cook islands', dial: '+682' },
  { code: 'CR', name: 'costa rica', dial: '+506' },
  { code: 'CI', name: 'cote d ivoire', dial: '+225' },
  { code: 'HR', name: 'croatia', dial: '+385' },
  { code: 'CU', name: 'cuba', dial: '+53' },
  { code: 'CW', name: 'curacao', dial: '+599' },
  { code: 'CY', name: 'cyprus', dial: '+357' },
  { code: 'CZ', name: 'czechia', dial: '+420' },
  { code: 'DK', name: 'denmark', dial: '+45' },
  { code: 'DJ', name: 'djibouti', dial: '+253' },
  { code: 'DM', name: 'dominica', dial: '+1767' },
  { code: 'DO', name: 'dominican republic', dial: '+1809' },
  { code: 'EC', name: 'ecuador', dial: '+593' },
  { code: 'EG', name: 'egypt', dial: '+20' },
  { code: 'SV', name: 'el salvador', dial: '+503' },
  { code: 'GQ', name: 'equatorial guinea', dial: '+240' },
  { code: 'ER', name: 'eritrea', dial: '+291' },
  { code: 'EE', name: 'estonia', dial: '+372' },
  { code: 'SZ', name: 'eswatini', dial: '+268' },
  { code: 'ET', name: 'ethiopia', dial: '+251' },
  { code: 'FK', name: 'falkland islands', dial: '+500' },
  { code: 'FO', name: 'faroe islands', dial: '+298' },
  { code: 'FJ', name: 'fiji', dial: '+679' },
  { code: 'FI', name: 'finland', dial: '+358' },
  { code: 'FR', name: 'france', dial: '+33' },
  { code: 'GF', name: 'french guiana', dial: '+594' },
  { code: 'PF', name: 'french polynesia', dial: '+689' },
  { code: 'GA', name: 'gabon', dial: '+241' },
  { code: 'GM', name: 'gambia', dial: '+220' },
  { code: 'GE', name: 'georgia', dial: '+995' },
  { code: 'DE', name: 'germany', dial: '+49' },
  { code: 'GH', name: 'ghana', dial: '+233' },
  { code: 'GI', name: 'gibraltar', dial: '+350' },
  { code: 'GR', name: 'greece', dial: '+30' },
  { code: 'GL', name: 'greenland', dial: '+299' },
  { code: 'GD', name: 'grenada', dial: '+1473' },
  { code: 'GP', name: 'guadeloupe', dial: '+590' },
  { code: 'GU', name: 'guam', dial: '+1671' },
  { code: 'GT', name: 'guatemala', dial: '+502' },
  { code: 'GG', name: 'guernsey', dial: '+44' },
  { code: 'GN', name: 'guinea', dial: '+224' },
  { code: 'GW', name: 'guinea-bissau', dial: '+245' },
  { code: 'GY', name: 'guyana', dial: '+592' },
  { code: 'HT', name: 'haiti', dial: '+509' },
  { code: 'HN', name: 'honduras', dial: '+504' },
  { code: 'HK', name: 'hong kong', dial: '+852' },
  { code: 'HU', name: 'hungary', dial: '+36' },
  { code: 'IS', name: 'iceland', dial: '+354' },
  { code: 'IN', name: 'india', dial: '+91' },
  { code: 'ID', name: 'indonesia', dial: '+62' },
  { code: 'IR', name: 'iran', dial: '+98' },
  { code: 'IQ', name: 'iraq', dial: '+964' },
  { code: 'IE', name: 'ireland', dial: '+353' },
  { code: 'IM', name: 'isle of man', dial: '+44' },
  { code: 'IL', name: 'israel', dial: '+972' },
  { code: 'IT', name: 'italy', dial: '+39' },
  { code: 'JM', name: 'jamaica', dial: '+1876' },
  { code: 'JP', name: 'japan', dial: '+81' },
  { code: 'JE', name: 'jersey', dial: '+44' },
  { code: 'JO', name: 'jordan', dial: '+962' },
  { code: 'KZ', name: 'kazakhstan', dial: '+7' },
  { code: 'KE', name: 'kenya', dial: '+254' },
  { code: 'KI', name: 'kiribati', dial: '+686' },
  { code: 'XK', name: 'kosovo', dial: '+383' },
  { code: 'KW', name: 'kuwait', dial: '+965' },
  { code: 'KG', name: 'kyrgyzstan', dial: '+996' },
  { code: 'LA', name: 'laos', dial: '+856' },
  { code: 'LV', name: 'latvia', dial: '+371' },
  { code: 'LB', name: 'lebanon', dial: '+961' },
  { code: 'LS', name: 'lesotho', dial: '+266' },
  { code: 'LR', name: 'liberia', dial: '+231' },
  { code: 'LY', name: 'libya', dial: '+218' },
  { code: 'LI', name: 'liechtenstein', dial: '+423' },
  { code: 'LT', name: 'lithuania', dial: '+370' },
  { code: 'LU', name: 'luxembourg', dial: '+352' },
  { code: 'MO', name: 'macao', dial: '+853' },
  { code: 'MG', name: 'madagascar', dial: '+261' },
  { code: 'MW', name: 'malawi', dial: '+265' },
  { code: 'MY', name: 'malaysia', dial: '+60' },
  { code: 'MV', name: 'maldives', dial: '+960' },
  { code: 'ML', name: 'mali', dial: '+223' },
  { code: 'MT', name: 'malta', dial: '+356' },
  { code: 'MH', name: 'marshall islands', dial: '+692' },
  { code: 'MQ', name: 'martinique', dial: '+596' },
  { code: 'MR', name: 'mauritania', dial: '+222' },
  { code: 'MU', name: 'mauritius', dial: '+230' },
  { code: 'YT', name: 'mayotte', dial: '+262' },
  { code: 'MX', name: 'mexico', dial: '+52' },
  { code: 'FM', name: 'micronesia', dial: '+691' },
  { code: 'MD', name: 'moldova', dial: '+373' },
  { code: 'MC', name: 'monaco', dial: '+377' },
  { code: 'MN', name: 'mongolia', dial: '+976' },
  { code: 'ME', name: 'montenegro', dial: '+382' },
  { code: 'MS', name: 'montserrat', dial: '+1664' },
  { code: 'MA', name: 'morocco', dial: '+212' },
  { code: 'MZ', name: 'mozambique', dial: '+258' },
  { code: 'MM', name: 'myanmar', dial: '+95' },
  { code: 'NA', name: 'namibia', dial: '+264' },
  { code: 'NR', name: 'nauru', dial: '+674' },
  { code: 'NP', name: 'nepal', dial: '+977' },
  { code: 'NL', name: 'netherlands', dial: '+31' },
  { code: 'NC', name: 'new caledonia', dial: '+687' },
  { code: 'NZ', name: 'new zealand', dial: '+64' },
  { code: 'NI', name: 'nicaragua', dial: '+505' },
  { code: 'NE', name: 'niger', dial: '+227' },
  { code: 'NG', name: 'nigeria', dial: '+234' },
  { code: 'NU', name: 'niue', dial: '+683' },
  { code: 'NF', name: 'norfolk island', dial: '+672' },
  { code: 'KP', name: 'north korea', dial: '+850' },
  { code: 'MK', name: 'north macedonia', dial: '+389' },
  { code: 'MP', name: 'northern mariana islands', dial: '+1670' },
  { code: 'NO', name: 'norway', dial: '+47' },
  { code: 'OM', name: 'oman', dial: '+968' },
  { code: 'PK', name: 'pakistan', dial: '+92' },
  { code: 'PW', name: 'palau', dial: '+680' },
  { code: 'PS', name: 'palestine', dial: '+970' },
  { code: 'PA', name: 'panama', dial: '+507' },
  { code: 'PG', name: 'papua new guinea', dial: '+675' },
  { code: 'PY', name: 'paraguay', dial: '+595' },
  { code: 'PE', name: 'peru', dial: '+51' },
  { code: 'PH', name: 'philippines', dial: '+63' },
  { code: 'PL', name: 'poland', dial: '+48' },
  { code: 'PT', name: 'portugal', dial: '+351' },
  { code: 'PR', name: 'puerto rico', dial: '+1787' },
  { code: 'QA', name: 'qatar', dial: '+974' },
  { code: 'RE', name: 'reunion', dial: '+262' },
  { code: 'RO', name: 'romania', dial: '+40' },
  { code: 'RU', name: 'russia', dial: '+7' },
  { code: 'RW', name: 'rwanda', dial: '+250' },
  { code: 'BL', name: 'saint barthelemy', dial: '+590' },
  { code: 'KN', name: 'saint kitts and nevis', dial: '+1869' },
  { code: 'LC', name: 'saint lucia', dial: '+1758' },
  { code: 'MF', name: 'saint martin', dial: '+590' },
  { code: 'PM', name: 'saint pierre and miquelon', dial: '+508' },
  { code: 'VC', name: 'saint vincent and the grenadines', dial: '+1784' },
  { code: 'WS', name: 'samoa', dial: '+685' },
  { code: 'SM', name: 'san marino', dial: '+378' },
  { code: 'ST', name: 'sao tome and principe', dial: '+239' },
  { code: 'SA', name: 'saudi arabia', dial: '+966' },
  { code: 'SN', name: 'senegal', dial: '+221' },
  { code: 'RS', name: 'serbia', dial: '+381' },
  { code: 'SC', name: 'seychelles', dial: '+248' },
  { code: 'SL', name: 'sierra leone', dial: '+232' },
  { code: 'SG', name: 'singapore', dial: '+65' },
  { code: 'SX', name: 'sint maarten', dial: '+1721' },
  { code: 'SK', name: 'slovakia', dial: '+421' },
  { code: 'SI', name: 'slovenia', dial: '+386' },
  { code: 'SB', name: 'solomon islands', dial: '+677' },
  { code: 'SO', name: 'somalia', dial: '+252' },
  { code: 'ZA', name: 'south africa', dial: '+27' },
  { code: 'KR', name: 'south korea', dial: '+82' },
  { code: 'SS', name: 'south sudan', dial: '+211' },
  { code: 'ES', name: 'spain', dial: '+34' },
  { code: 'LK', name: 'sri lanka', dial: '+94' },
  { code: 'SD', name: 'sudan', dial: '+249' },
  { code: 'SR', name: 'suriname', dial: '+597' },
  { code: 'SE', name: 'sweden', dial: '+46' },
  { code: 'CH', name: 'switzerland', dial: '+41' },
  { code: 'SY', name: 'syria', dial: '+963' },
  { code: 'TW', name: 'taiwan', dial: '+886' },
  { code: 'TJ', name: 'tajikistan', dial: '+992' },
  { code: 'TZ', name: 'tanzania', dial: '+255' },
  { code: 'TH', name: 'thailand', dial: '+66' },
  { code: 'TL', name: 'timor-leste', dial: '+670' },
  { code: 'TG', name: 'togo', dial: '+228' },
  { code: 'TK', name: 'tokelau', dial: '+690' },
  { code: 'TO', name: 'tonga', dial: '+676' },
  { code: 'TT', name: 'trinidad and tobago', dial: '+1868' },
  { code: 'TN', name: 'tunisia', dial: '+216' },
  { code: 'TR', name: 'turkey', dial: '+90' },
  { code: 'TM', name: 'turkmenistan', dial: '+993' },
  { code: 'TC', name: 'turks and caicos islands', dial: '+1649' },
  { code: 'TV', name: 'tuvalu', dial: '+688' },
  { code: 'UG', name: 'uganda', dial: '+256' },
  { code: 'UA', name: 'ukraine', dial: '+380' },
  { code: 'AE', name: 'united arab emirates', dial: '+971' },
  { code: 'GB', name: 'united kingdom', dial: '+44' },
  { code: 'US', name: 'united states', dial: '+1' },
  { code: 'UY', name: 'uruguay', dial: '+598' },
  { code: 'UZ', name: 'uzbekistan', dial: '+998' },
  { code: 'VU', name: 'vanuatu', dial: '+678' },
  { code: 'VA', name: 'vatican city', dial: '+379' },
  { code: 'VE', name: 'venezuela', dial: '+58' },
  { code: 'VN', name: 'vietnam', dial: '+84' },
  { code: 'WF', name: 'wallis and futuna', dial: '+681' },
  { code: 'YE', name: 'yemen', dial: '+967' },
  { code: 'ZM', name: 'zambia', dial: '+260' },
  { code: 'ZW', name: 'zimbabwe', dial: '+263' },
];

// Several countries share a dial code. A stored number only carries the dial
// code, so these pick which country the phone box shows when parsing one back.
const primaryCountryByDial = {
  '+1': 'US',
  '+7': 'RU',
  '+44': 'GB',
  '+262': 'RE',
  '+590': 'GP',
  '+599': 'CW',
};

export const getCountry = (countryCode) =>
  countryDialCodes.find((country) => country.code === countryCode) ?? null;

// Splits a stored value such as '+971501234567' into the country that owns the
// dial code and the remaining national digits. Numbers saved before the country
// selector existed have no '+', so they come back with no country and keep all
// of their digits.
export const splitPhoneValue = (value) => {
  const stored = String(value ?? '').replace(/[^\d+]/g, '');

  if (!stored.startsWith('+')) return { country: null, national: stored };

  const [match] = countryDialCodes
    .filter((country) => stored.startsWith(country.dial))
    .sort((a, b) => b.dial.length - a.dial.length);

  if (!match) return { country: null, national: stored.slice(1) };

  return {
    country: primaryCountryByDial[match.dial] ?? match.code,
    national: stored.slice(match.dial.length),
  };
};

// Builds the value sent to the API. Without a country the digits are returned
// unprefixed so schema validation reports the missing country to the user.
export const joinPhoneValue = (countryCode, nationalNumber) => {
  const digits = String(nationalNumber ?? '').replace(/\D/g, '');
  const country = getCountry(countryCode);

  if (!country || !digits) return digits;

  return `${country.dial}${digits}`;
};
